<template>    
    <div class="box">
        <div class="relative">
            <div class="px-6 py-4" :class="{ 'border-b border-grey-lighter': !hidden }" @click="hidden = ! hidden">
                <slot name="header" />
            </div>
            <div class="px-6 py-4" v-if="!hidden">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'app-collapseable-box',

        data: () => ({
            hidden: true
        }),

        computed: {
            hasFooterSlot() {
                return !!this.$slots['footer'];
            },
            isEmpty() {
                return (typeof this.$slots.default != 'undefined') ? false : true;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .box {
        @apply .bg-white .shadow-lg;
    }
</style>


// WEBPACK FOOTER //
// src/components/CollapseableBox.vue